import './styles/simonsLayout.css';
import LoadLinkData from "./LoadLinkData";

export default function InterestingLinks() {
    return (<>
            <link rel="icon" href="/images/sk/sphere.ico"/>
            <title>Interesting Links found out there</title>
            <div className="skbackground">
                <br/>
                <h1>Interesting Links</h1>
                <div className="normcontent">
                    <LoadLinkData formedName="/data/linkdata1.json" boxhead={"mainboxhead"}
                                  boxbody={"mainboxbody"}/>
                </div>
                <div className="normcontent">
                    <LoadLinkData formedName="/data/linkdata2.json" boxhead={"mainboxhead"}
                                  boxbody={"mainboxbody"}/>
                </div>
                <div className="normcontent">
                    <LoadLinkData formedName="/data/linkdata3.json" boxhead={"mainboxhead"}
                                  boxbody={"mainboxbody"}/>
                </div>
                <div className="normcontent">
                    <LoadLinkData formedName="/data/linkdata4.json" boxhead={"mainboxhead"}
                                  boxbody={"mainboxbody"}/>
                </div>
                <div className="normcontent">
                    <LoadLinkData formedName="/data/linkdata5.json" boxhead={"mainboxhead"}
                                  boxbody={"mainboxbody"}/>
                </div>
                <div className="normcontent">
                    <LoadLinkData formedName="/data/linkdata6.json" boxhead={"mainboxhead"}
                                  boxbody={"mainboxbody"}/>
                </div>
                <div className="normcontent">
                    <LoadLinkData formedName="/data/linkdata7.json" boxhead={"mainboxhead"}
                                  boxbody={"mainboxbody"}/>
                </div>
                <div className="normcontent">
                    <LoadLinkData formedName="/data/linkdata8.json" boxhead={"mainboxhead"}
                                  boxbody={"mainboxbody"}/>
                </div>
                <div className="normcontent">
                    <LoadLinkData formedName="/data/linkdata9.json" boxhead={"mainboxhead"}
                                  boxbody={"mainboxbody"}/>
                </div>
            </div>
        </>
    );
}

